import React from 'react';
import BookStore from '../../stores/book-store';
import ModalButtons from '../layouts/modal-buttons';
import { VstInput } from 'vstui';

class MobileGoToPage extends React.Component {

  constructor() {
    super();
    this.state = {
      error: '',
      page: ''
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    Fraction.Helpers.runAfterRender(function(){
      document.getElementById('mobileGoToPageInput').focus();
    });
  }

  _onError(error) {
    this.setState({ error }, () => { document.getElementById('mobileGoToPageInput').focus() });
  }

  onChange(e) {
    this.setState({page: e.currentTarget.value, error: ''});
  }

  onSubmit(e) {
    e.preventDefault();
    const book = BookStore.get(this.props.isbn);
    const { page } = this.state;
    if (page === '') {
      this._onError(i18n.t('print.required'));
    } else {
      const callback = data => {
        const message = data && data.message;
        const jpo = document.getElementById('jigsaw-placeholder-outer');
        if (message === 'page not found') {
          this._onError(i18n.t("reader.page-dne", { page }));
          Fraction.Helpers.removeLoader(jpo);
        } else {
          book.viewer.Viewport.focus();
          this.props.updatePageCallback(page);
          Fraction.Helpers.removeModal();
        }

        Fraction.Reporter.gaEvent("reader/navigation/goToPageMobile", `page: ${page} (${message || 'no-message'})`);
      };

      book.goTo({ page, callback });
    }
  }

  render() {
    return (
      <div className="go-to-page-mobile-dialog">
        <form onSubmit={this.onSubmit}>
          <VstInput
            id="mobileGoToPageInput"
            label={i18n.t('reader.page-number')}
            placeholder={i18n.t('reader.page-number')}
            failure={this.state.error}
            onChange={this.onChange}
            value={this.state.page}
            />
          <ModalButtons>
            <button
              className="cancel"
              onClick={Fraction.Helpers.removeModal}
              type="button"
              >
              {i18n.t('base.cancel')}
            </button>
            <button type="submit">
              {i18n.t('base.go')}
            </button>
          </ModalButtons>
        </form>
      </div>
    );
  }

}

const _showMobileGoToPage = (isbn, updatePageCallback) => {
  Fraction.Helpers.showModal({
    title: i18n.t('reader.go-to-page'),
    content:
      <MobileGoToPage
        isbn={isbn}
        updatePageCallback={updatePageCallback}
        />,
    width: 200,
    closeCallback: function(){},
    buttons: [],
    delegateButtons: true,
    definingClass: 'mobile-go-to-page'
  }, document.querySelectorAll("#jigsaw-placeholder-outer iframe")[0]);
  // TODO :: There are better ways to focus now Viewport.focus()
};

export default _showMobileGoToPage;
